"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _common = require("teacherDashboard/teacher/config/class_left_nav_container/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CircleAnimation = function CircleAnimation() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "circle-animation",
    "data-sentry-component": "CircleAnimation",
    "data-sentry-source-file": "index.tsx"
  }, " ", /*#__PURE__*/_react["default"].createElement("img", {
    src: _common.ImagePaths.loaderGif
  }), " ");
};
var _default = CircleAnimation;
exports["default"] = _default;